<template>
  <div>
    <div class="pull-to-refresh-ios__spinner">
      <div class="pull-to-refresh-ios__blade"></div>
      <div class="pull-to-refresh-ios__blade"></div>
      <div class="pull-to-refresh-ios__blade"></div>
      <div class="pull-to-refresh-ios__blade"></div>
      <div class="pull-to-refresh-ios__blade"></div>
      <div class="pull-to-refresh-ios__blade"></div>
      <div class="pull-to-refresh-ios__blade"></div>
      <div class="pull-to-refresh-ios__blade"></div>
      <div class="pull-to-refresh-ios__blade"></div>
      <div class="pull-to-refresh-ios__blade"></div>
      <div class="pull-to-refresh-ios__blade"></div>
      <div class="pull-to-refresh-ios__blade"></div>
    </div>
    <main class="pull-to-refresh-ios__main">
      <slot />
    </main>
  </div>
</template>

<script lang="ts">
// @ts-ignore
import pullToRefresh from "mobile-pull-to-refresh";
// @ts-ignore
import ptrAnimatesIos from "mobile-pull-to-refresh/dist/styles/ios/animates";
import { showErrorModal } from "@/utils/showErrorModal";
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({
  components: {}
})
export default class PullToRefresh extends Vue {
  // trueの間はローディングを表示することができる
  // falseになってしばらくするとローディングが止まる
  @Prop({
    default: true,
    type: Boolean
  })
  isShowingPullToRefreshLoading!: boolean;

  mounted() {
    pullToRefresh({
      // FIXME: グローバルアクセスなので直したい
      container: document.querySelector(".container"),
      animates: ptrAnimatesIos,
      refresh: this.onRefresh
    });
  }

  async onRefresh() {
    this.$emit("pull");

    const wait = (ms: number) =>
      new Promise(resolve => {
        setTimeout(resolve, ms);
      });

    // .25秒ごとにチェック。30秒時間過ぎると強制的にローディング終了
    // FIXME: もうちょっとスマートに書きたい
    for (let i = 0; i < 4 * 30; i++) {
      await wait(250);
      if (!this.isShowingPullToRefreshLoading) {
        this.$emit("end-loading");
        return;
      }
    }

    this.$emit("end-loading");
    await showErrorModal(this, new Error("予期せぬエラーが発生しました"));
  }
}
</script>

<style lang="scss" scoped>
.pull-to-refresh-ios__spinner {
  z-index: 999;
}
</style>
